module.exports = __webpack_public_path__ + "img/certificate-es.03c29d7c.png";